module.exports = __webpack_public_path__ + "static/media/fly0106.85e3e8dd.webp";